import Breadcrumb from './Breadcrumb';
import DetailBreadcrumb from './DetailBreadcrumb';

export { Breadcrumb, DetailBreadcrumb };
export default Breadcrumb;
